import { SVGProps } from 'react';

const FileClock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14 2v4a2 2 0 0 0 2 2h4m-4 14h2a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3m4 7v2.2l1.6 1M14 16a6 6 0 1 1-12 0 6 6 0 0 1 12 0"
    />
  </svg>
);
export default FileClock;
